<div class="wrapper">
  <div class="field">
    <ng-container #fieldComponent></ng-container>
  </div>
  <p [innerHTML]="field.hintText"></p>
</div>